import Icon_Point from "../../../assets/png/Icon_Point.png";
const NZElectricFeatures = () => {
    return (
        <div className="bg-white pt-[60px] pb-[60px]">
            <div className="custom-container px-[30px] text-start mx-auto ">
                <div className="max-w-[1200px]  mx-auto">
                    <div className="kuunari-bold text-[30px] leading-[71px] text-center ">2025 Model</div>
                    <div className="text-[20px] leading-[50px] text-center mb-[20px]">FEATURES</div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-screen-xl mx-auto">

                        <div>
                            <ul className="list-none text-[#666] text-lg leading-7 space-y-4">
                                {[
                                    "Powerful 15kW water-cooled electric motor.",
                                    "Low running costs – estimated at 3 cents per kilometre.",
                                    "Minimum servicing requirements - e.g. no air intake, no fuel system, no exhaust system.",
                                    "Regenerative braking provides engine braking when descending  steep inclines and recharges the battery on the run at the same time.",
                                    "Battery range of 70-175Km depending on the battery size, terrain, and cargo load.",
                                    "Lithium iron phosphate battery packs  (Generally considered the best all-around battery type for EVs).",
                                    "Three battery capacities: 12kWh, 21kWh, and 26.5kWh.",
                                    "Semi-automatic, high/low ratio transmission.",
                                    "Massive cargo deck – 1600 x 1400 x 300 (mm), 550kg carrying capacity.",
                                    "Maximum towing capacity of 1,000 kgs.",
                                    "Selectable  2WD/4WD.",          
                                    "Selectable front and rear differential lock (or both simultaneously).",                         
                                ].map((item, index) => (
                                    <li key={index} className="flex items-start gap-3">
                                        <img src={Icon_Point} className="w-5 h-5 mt-1" alt="icon" />
                                        <span>{item}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>


                        <div>
                            <ul className="list-none text-[#666] text-lg leading-7 space-y-4">
                                {[
                                    
                                    "LED headlights, fog lights, and a powerful roof-mounted LED light bar.",
                                    "Waterproof radio and speakers with Bluetooth.",
                                    "Range of tyre options from high grip to turf.",
                                    "Electrophoresis anti-corrosion treatment and undersealed cargo decks.",
                                    "D-ring tie-downs (Front & rear cargo trays).",
                                    "Tilt-adjustable steering wheel with power steering.",
                                    "Hydraulic disc brakes all around with vacuum booster.",
                                    // "Flatbed front cargo tray with 150kg carrying capacity.",
                                    "Electric cabin-operated cargo tray tip function.",
                                    "PVC roof with carry tray.",
                                    "1 x 12V DC outlet and a dual USB connector for cell phone or other accessory charging.",
                                    "Adjustable rear drawbar with tow ball.",
                                    "Electric-assisted power steering."
                                ].map((item, index) => (
                                    <li key={index} className="flex items-start gap-3">
                                        <img src={Icon_Point} className="w-5 h-5 mt-1" alt="icon" />
                                        <span>{item}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    );
};
export default NZElectricFeatures;
